'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
var styles = require('@material-ui/core/styles');
var StatusBadge = require('../StatusBadge/StatusBadge.js');
var types = require('./types.js');
var utils = require('./utils.js');

var fmBase = 'componentLib.appointmentRequestStatusBadge';
var AppointmentRequestStatusBadge = function (props) {
    var status = props.status;
    var palette = styles.useTheme().palette;
    var fm = reactIntl.useIntl().formatMessage;
    var green = palette.success.dark;
    var red = palette.error.dark;
    var yellow = palette.warning.dark;
    var blue = palette.primary.main;
    var StatusColors = utils.getStatusColors(yellow, green, red, blue);
    return (React__default.createElement(StatusBadge, { label: fm({ id: fmBase + "." + status }), color: StatusColors[types.AppointmentRequestStatusType[status]] }));
};

module.exports = AppointmentRequestStatusBadge;
